export async function getProjectSharedLibraries(maxDepth = 5) {
  if (maxDepth < 1) {
    return []
  }

  const startId = this.getRootState('id')

  const queue = [{ id: startId, depth: 0 }]
  const visited = new Set([startId])
  const librariesSet = new Set()

  while (queue.length > 0) {
    const { id: currentId, depth } = queue.shift()

    // Only process projects within the depth limit
    if (depth >= maxDepth) {
      break // Exit if we've reached the max depth
    }

    try {
      // eslint-disable-next-line no-await-in-loop
      const libs = await this.sdk.getProjectLibraries(currentId)
      if (!libs || libs.length === 0) {
        // eslint-disable-next-line no-continue
        continue // Skip if no libraries found
      }

      for (const lib of libs) {
        // Add library to result set
        if (!librariesSet.has(lib.id)) {
          librariesSet.add(lib.id)
        }

        // Enqueue if we haven't visited and within depth limit
        if (!visited.has(lib.id)) {
          visited.add(lib.id)
          // eslint-disable-next-line max-depth
          if (depth + 1 < maxDepth) {
            queue.push({ id: lib.id, depth: depth + 1 })
          }
        }
      }
    } catch (error) {
      console.error(`Error fetching libraries for ${currentId}:`, error)
    }
  }

  return Array.from(librariesSet)
}
